import dayjs, { Dayjs } from 'dayjs';
import { changePeriod } from './utils';

export const getDateRange = (period: string): { start: Dayjs; end: Dayjs } => {
  return {
    start: dayjs().subtract(+period, 'hours'),
    end: dayjs(),
  };
};

export const updateDateRange = ({
  dateRange,
  period,
  isZoom,
  chartId,
  saveOnLocalStorage,
  alarmDateRange,
  defaultPeriod,
  setDateRange,
  setPeriod,
  isFlaring,
}: {
  dateRange?: { start: Dayjs; end: Dayjs | null };
  period?: string;
  isZoom?: boolean;
  chartId: string;
  saveOnLocalStorage: (data: any, chartId: string) => void;
  alarmDateRange?: { start: Dayjs; end: Dayjs };
  defaultPeriod: string;
  setDateRange: (range: { start: Dayjs; end: Dayjs }) => void;
  setPeriod: (period: string) => void;
  isFlaring?: boolean;
}) => {
  if (isZoom && dateRange) {
    setDateRange({ start: dayjs(dateRange.start), end: dayjs(dateRange.end) });
    saveOnLocalStorage(
      {
        zoomInterval: dateRange,
      },
      chartId,
    );
    return;
  }
  if (!isZoom) {
    saveOnLocalStorage(
      {
        period,
        dateRange,
        zoomInterval: undefined,
      },
      chartId,
    );
  }
  if (period === 'alarm' && alarmDateRange) {
    setPeriod(period);
    setDateRange(changePeriod(alarmDateRange, period));
    return;
  }

  if (dateRange) {
    setDateRange({ start: dayjs(dateRange.start), end: dayjs(dateRange.end) });
    return;
  }

  if (period) {
    setPeriod(period);

    if (alarmDateRange) {
      setDateRange(!isFlaring ? changePeriod(alarmDateRange, period) : getDateRange(period));
      return;
    }
  }
  if (period === 'alarm' && !alarmDateRange) {
    setDateRange(getDateRange(defaultPeriod));
    return;
  }

  setDateRange(getDateRange(period ?? defaultPeriod));
};
